var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperWithCalc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 19.3333C11.667 13.0479 11.667 9.90524 13.6196 7.95262C15.5722 6 18.7149 6 25.0003 6H28.3337C34.6191 6 37.7617 6 39.7144 7.95262C41.667 9.90524 41.667 13.0479 41.667 19.3333V26C41.667 32.2854 41.667 35.4281 39.7144 37.3807C37.7617 39.3333 34.6191 39.3333 28.3337 39.3333H25.0003C18.7149 39.3333 15.5722 39.3333 13.6196 37.3807C11.667 35.4281 11.667 32.2854 11.667 26V19.3333Z",
    fill: "#E7EDFF",
    stroke: "#081E54",
    strokeWidth: 0.875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.834 22.25H33.334",
    stroke: "#081E54",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.834 16.4219H33.334",
    stroke: "#081E54",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 27.6719L33.3337 27.6719",
    stroke: "#081E54",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17544 41.8268C8.51786 43.1693 10.6785 43.1693 14.9997 43.1693C19.3209 43.1693 21.4815 43.1693 22.8239 41.8268C24.1663 40.4844 24.1663 38.3238 24.1663 34.0026C24.1663 29.6814 24.1663 27.5208 22.8239 26.1784C21.4815 24.8359 19.3209 24.8359 14.9997 24.8359C10.6785 24.8359 8.51786 24.8359 7.17544 26.1784C5.83301 27.5208 5.83301 29.6814 5.83301 34.0026C5.83301 38.3238 5.83301 40.4844 7.17544 41.8268Z",
    fill: "white",
    stroke: "#081E54"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 30.7942H16.8333M20.5 36.2943H16.8333M20.5 39.0443H16.8333M13.1667 30.7943H11.3333M11.3333 30.7943L9.5 30.7943M11.3333 30.7943L11.3333 28.9609M11.3333 30.7943L11.3333 32.6276M12.7083 36.2943L11.3333 37.6693M11.3333 37.6693L9.95834 39.0443M11.3333 37.6693L9.95833 36.2943M11.3333 37.6693L12.7083 39.0443",
    stroke: "#A020FF",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperWithCalc);
export default __webpack_public_path__ + "static/media/PaperWithCalc.54f6056f41bdfc75ae269a9e2e819357.svg";
export { ForwardRef as ReactComponent };